import React from "react";
import { motion } from "framer-motion";
import { REVEAL } from "@/lib/motion";

export const HomeResults = () => (
  <section className="px-6 sm:px-8 pb-20 sm:pb-28" data-testid="home-results">
    <div className="max-w-5xl mx-auto">
      <motion.h2 {...REVEAL} className="font-fraunces font-extrabold text-3xl sm:text-4xl tracking-tight text-[#1F1F1C]">
        Results
      </motion.h2>

      <div
        className="mt-10 bg-[#EADCC6] rounded-2xl border border-dashed border-[#1F1F1C]/20 px-8 py-16 text-center"
        data-testid="results-placeholder"
      >
        <p className="text-base md:text-lg text-[#4A463F]">Case study coming soon</p>
      </div>

      <div className="mt-5 grid sm:grid-cols-3 gap-5" data-testid="testimonial-slots">
        {[1, 2, 3].map((n) => (
          <div
            key={n}
            className="rounded-2xl border border-dashed border-[#1F1F1C]/20 px-6 py-12 text-center"
            data-testid={`testimonial-slot-${n}`}
          >
            <p className="text-sm text-[#4A463F]">Client quote coming soon</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default HomeResults;
